module.exports = __webpack_public_path__ + "img/fire.0afeefdb.gif";